export const equipeConstants = {
    EQUIPE_LOADING: 'EQUIPE_LOADING',
    GETEQUIPE_SUCCESS: 'GET_EQUIPE_SUCCESS',
    GETEQUIPE_FAILURE: 'GET_EQUIPE_FAILURE',
    PUTEQUIPE_SUCCESS: 'PUT_EQUIPE_SUCCESS',
    PUTEQUIPE_FAILURE: 'PUT_EQUIPE_FAILURE',
}
